<template>
  <div class="d-inline-flex align-center">
    <v-chip
      v-if="returnedProductId"
      x-small
      label
      color="teal"
      text-color="white"
      class="mr-1"
    >
      <v-icon x-small left>
        mdi-check-circle
      </v-icon>
      Returned
    </v-chip>
    <v-btn
      v-else
      v-bind="$attrs"
      color="teal"
      text
      x-small
      @click="() => $emit('click', submit)"
    >
      <v-icon small left>
        mdi-swap-horizontal
      </v-icon>
      Return
    </v-btn>
  </div>
</template>

<script>
import { authAxios } from '@/extra-functions/axios.extra'
import { ErrorPopup, LoadingPopup, SuccessPopup } from '@/lib/utils'

export default {
  name: 'ReturnProductBtn',
  props: {
    saleInventoryId: { type: [Number, String], default: null },
    consumerLoanInventoryId: { type: [Number, String], default: null },
    returnedProductId: { type: [Number, String], default: null },
  },
  methods: {
    /**
     * @param {{ goodOrderQuantity: number, badOrderQuantity: number }} params
     */
    async submit(params) {
      const totalQty = (params.goodOrderQuantity || 0) + (params.badOrderQuantity || 0)
      const refKey = this.saleInventoryId != null
        ? 'sale_inventory_id'
        : 'consumer_loan_inventory_id'
      const refId = this.saleInventoryId ?? this.consumerLoanInventoryId

      LoadingPopup.fire('Loading', 'Saving return...')
      try {
        await authAxios().post('/v2/returned-products', {
          data: {
            [refKey]: refId,
            quantity: totalQty,
            bad_order_quantity: params.badOrderQuantity || 0,
            date_returned: new Date().toISOString().slice(0, 19).replace('T', ' '),
          },
        })
        SuccessPopup.fire('Success', 'Product returned successfully')
      } catch (e) {
        const msg = e?.response?.data?.message || e?.message || 'Unexpected error'
        ErrorPopup.fire('Error', msg)
        throw e
      }
    },
  },
}
</script>
